import { Injectable, OnInit } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocationLoader implements OnInit {

    // FIELDS
    // PROPERTIES
    // CONSTRUCTORS
    // LIFECYCLE

    ngOnInit() {
    }

    // APIs

    // HELPERS


}
